import React, { useState, useEffect } from 'react';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';

const FeedbackForm = (props) => {
    const [ feedbackOption, setFeedbackOption ] = useState('');
    const [ feedbackCopy, setFeedbackCopy ] = useState('');
    const [ feedbackError, setFeedbackError ] = useState('');
    const [ feedbackRequiredError, setfeedbackRequiredError ] = useState('');

    let feedbackReasons = {
        features: {
            label: 'Missing features',
            needsFeedback: true,
            feedbackLabel: 'Please let us know what features are missing'
        },
        issue: {
            label: 'Technical issue',
            needsFeedback: true,
            feedbackLabel: "Please let us know what issue you're having"
        },
        underutilized: {
            label: 'Not using all the features',
            needsFeedback: false,
            feedbackLabel: ''
        },
        cost: {
            label: 'Too expensive',
            needsFeedback: false,
            feedbackLabel: ''
        },
        competitor: {
            label: 'Found another solution',
            needsFeedback: true,
            feedbackLabel: 'What solution are you planning to use?'
        },
        somethingElse: {
            label: 'Something else',
            needsFeedback: true,
            feedbackLabel: "Please let us know what issue you're having"
        },
    }

    const clickOption = (e) => {
        let key = e.currentTarget.dataset.reason;

        if (key !== feedbackOption) {
            setFeedbackCopy('');
            setFeedbackOption(key);
        }

    }

    const onContinueClick = (e) => {
        let optionData = feedbackReasons[feedbackOption];
        setFeedbackError('');

        if (feedbackOption === '') {
            setfeedbackRequiredError("Please let us know why you're leaving.");
            return
        }

        if (optionData.needsFeedback && !feedbackCopy) {
            setFeedbackError("Please provide some feedback");
            return;
        }

        if (props.recordEvent) {
            props.recordEvent({
                pub_id: props.user.detail.id,
                event_name: 'Cancellation Feedback',
                event_data: {
                    reason: optionData.label,
                    detail: feedbackCopy
                }
            });
        }

        if (feedbackOption === 'issue') {
            props.advance(6);
        } else {
            props.advance(3);
        }

    }

    return (
        <div className="feedback-form-wrapper">
            <div className="feedback-form">
                <div className="feedback-collection">
                    <div className="feedback-title">
                        <div className="title-main">
                            We're sorry to see you go.
                        </div>
                        <div className="title-sub">
                            Please let us know why you're leaving so we can improve.
                        </div>
                    </div>
                    <div className="feedback-options">
                        {feedbackRequiredError ? (
                            <p className="required-error">{feedbackRequiredError}</p>
                        ) : null}
                        {Object.keys(feedbackReasons).map((key) => {
                            let reason = feedbackReasons[key],
                                optionClass = 'feedback-option',
                                optionContent = null,
                                feedbackErrorElement = null;

                            if (feedbackError) {
                                feedbackErrorElement = (
                                    <p className="option-error">{feedbackError}</p>
                                );
                            }

                            if (reason.needsFeedback && key === feedbackOption) {
                                optionContent = (
                                    <div className="option-feedback">
                                        <p>{reason.feedbackLabel}</p>
                                        <UncontrolledTextInput
                                            isTextArea={true}
                                            onChange={(e) => {
                                                setFeedbackCopy(e.currentTarget.value);
                                            }}
                                            value={feedbackCopy}/>
                                        {feedbackErrorElement}
                                    </div>
                                );
                            }

                            return (
                                <div key={key} className={optionClass} onClick={clickOption} data-reason={key}>
                                    <div className="option-label">
                                        <input type="radio" checked={(key === feedbackOption) ? true : false} onChange={clickOption} data-reason={key}/> {reason.label}
                                    </div>
                                    {optionContent}
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="action-buttons">
                    <div className="action-button main" onClick={(e) => {
                        props.closeAllModals();
                    }}>
                        Nevermind
                    </div>
                    <div className="action-button secondary" onClick={onContinueClick}>
                        Continue
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeedbackForm;
